/* Maison Sabelle quick add: any house card form (.sbc__form) adds to the bag in place and opens Horizon's cart
   drawer, by sending the same standard cart event Horizon's own product form sends. Without the events module
   (or JavaScript) the form still posts to /cart/add as normal. */

let events = null;
const loadEvents = () => {
  if (!events) events = import('@shopify/events').catch(() => null);
  return events;
};

export async function addToBag(form, source = 'sabelle-card') {
  const data = new FormData(form);
  const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  if (ids.length) data.append('sections', ids.join(','));

  const mod = await loadEvents();
  const Ev = mod?.CartLinesUpdateEvent;
  const deferred = Ev?.createPromise?.();
  if (Ev && deferred) {
    form.dispatchEvent(new Ev({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity')) || 1 }],
      promise: deferred.promise,
    }));
  }

  const routes = window.Theme?.routes || {};
  try {
    const res = await fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    }).then((r) => r.json());
    const cart = await fetch(`${routes.cart_url || '/cart'}.json`).then((r) => r.json());
    const failed = Boolean(res.status);
    deferred?.resolve({
      cart: Ev.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source, itemCount: 1, sections: failed ? undefined : res.sections, didError: failed },
    });
    if (failed) throw new Error(res.description || res.message || 'That could not be added.');
    return true;
  } catch (err) {
    deferred?.reject?.(err);
    throw err;
  }
}

if (!window.__sabelleQuickAdd) {
  window.__sabelleQuickAdd = true;
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.sbc__form')) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
    const label = btn.textContent;
    btn.classList.add('is-busy');
    try {
      await addToBag(form);
      btn.textContent = 'Added';
    } catch (err) {
      btn.textContent = 'Try again';
    } finally {
      btn.classList.remove('is-busy');
      setTimeout(() => { btn.textContent = label; }, 2000);
    }
  });
  loadEvents();
}
